import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-entity-follow-header',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="entity-follow-header">
      <h2 class="entity-follow-title">{{ name }}</h2>
      <app-star-toggle
        *ngIf="showActions"
        [active]="active"
        [ignored]="ignored"
        [allowIgnore]="allowIgnore"
        [fullButton]="true"
        [labels]="labels"
        [activeLabel]="activeLabel"
        [isLoading]="isLoading"
        (toggled)="toggled.emit($event)"
        (ignoreToggled)="ignoreToggled.emit($event)"
        (labelToggled)="labelToggled.emit($event)"
      ></app-star-toggle>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
        font-family: 'Nunito Sans', sans-serif;
      }

      .entity-follow-header {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 0.65rem 1rem;
        min-height: 2.5rem;
      }

      .entity-follow-title {
        margin: 0;
        color: #3e5569;
        font-size: 2rem;
        font-weight: 700;
        line-height: 1.15;
      }
    `,
  ],
})
export class EntityFollowHeaderComponent {
  @Input() name: string;
  @Input() active = false;
  @Input() ignored = false;
  @Input() allowIgnore = false;
  @Input() labels: string[] = [];
  @Input() activeLabel: string = null;
  @Input() isLoading = false;
  @Input() showActions = true;

  @Output() toggled = new EventEmitter<boolean>();
  @Output() ignoreToggled = new EventEmitter<boolean>();
  @Output() labelToggled = new EventEmitter<string>();
}
